import { BookOpenCheckIcon, FileTextIcon, FolderOpenIcon, ListChecksIcon, SearchCheckIcon } from 'lucide-react';
import type { LucideIcon } from 'lucide-react';

export type Bonus = {
  number: string;
  title: string;
  description: string;
  items?: string[];
  benefit: string;
  value: string;
  icon: LucideIcon;
  wide?: boolean;
};

export const bonuses: Bonus[] = [
  {
    number: '01',
    title: '150 Industrial Maintenance Classroom Activities & Challenges',
    description:
      '150 ready-to-use activity ideas covering industrial maintenance fundamentals, mechanical systems, electrical systems, hydraulic and pneumatic systems, preventive and predictive maintenance, reliability analysis, failure analysis, planning and work management, safety and risk, troubleshooting, evidence analysis, problem-solving, maintenance decision-making, and integrated industrial situations. Organized by difficulty level and topic.',
    benefit: 'Materials already designed for your classroom: saves hours every quarter.',
    value: 'USD 14',
    icon: FolderOpenIcon,
  },
  {
    number: '02',
    title: 'Industrial Maintenance Assessment Bank',
    description:
      'Comprehensive assessment resources designed to evaluate student learning throughout an industrial maintenance course. Includes:',
    items: [
      'Foundational level assessments',
      'Intermediate level assessments',
      'Advanced level assessments',
      'Short-answer questions',
      'True/false questions with justification',
      'Concept understanding exercises',
      'Application questions',
      'Industrial scenarios',
      'Evidence interpretation',
      'Trend interpretation',
      'Reliability metrics',
      'Maintenance strategy decisions',
      'Safety reasoning',
      'Technical communication',
      'Integrated problems',
      'Teacher guidance',
    ],
    benefit: 'Never build an exam from scratch under pressure again.',
    value: 'USD 14',
    icon: ListChecksIcon,
  },
  {
    number: '03',
    title: '100 Industrial Maintenance Case Studies & Problem-Solving Scenarios',
    description:
      'A collection of 100 developed industrial maintenance cases involving mechanical systems, electrical and control systems, hydraulic and pneumatic systems, preventive and predictive maintenance, reliability and recurring failures, planning and scheduling, safety and human factors, and integrated industrial scenarios.',
    benefit:
      'Students analyze facts, evaluate evidence, identify root causes, and develop maintenance recommendations.',
    value: 'USD 14',
    icon: FileTextIcon,
  },
  {
    number: '04',
    title: 'Industrial Maintenance Troubleshooting & Diagnostic Reasoning Guide',
    description:
      'A comprehensive guide focused on teaching students how to think through equipment failures systematically. Includes:',
    items: [
      'Think Before You Fix: Troubleshooting as Evidence-Based Reasoning',
      'Diagnostic Reasoning Framework: A Process Students Can Reuse',
      'From Symptoms to Root Causes: Avoiding Premature Conclusions',
      'Reading the Evidence Across Industrial Systems',
      'History, Trends, Safety Boundaries & Human Factors',
      'Diagnostic Records, Practice Exercises & Final Troubleshooting Challenges',
    ],
    benefit: 'With practical exercises in mechanical, electrical, and hydraulic diagnostic reasoning.',
    value: 'USD 14',
    icon: SearchCheckIcon,
  },
  {
    number: '05',
    title: 'Industrial Maintenance Concept & Terminology Guide: 200 Essential Concepts Explained',
    description:
      'Comprehensive reference handbook covering 200 essential industrial maintenance concepts designed to help teachers explain vocabulary and concepts clearly. Includes terminology related to:',
    items: [
      'Maintenance Fundamentals',
      'Mechanical Maintenance',
      'Electrical & Control Systems',
      'Hydraulic & Pneumatic Systems',
      'Preventive, Predictive & Condition Monitoring',
      'Reliability & Failure Analysis',
      'Planning, Scheduling & Work Management',
      'Safety & Risk Management',
      'Troubleshooting & Diagnostic Reasoning',
    ],
    benefit: 'Project it in class and your students instantly understand complex industrial maintenance concepts.',
    value: 'USD 14',
    icon: BookOpenCheckIcon,
    wide: true,
  },
];
